import { ClickableProps } from '../clickable';
import { DEFAULT_STATE_MODE } from './const';
import { StateMode } from './enums';
import css from './style.module.css';

export const shouldMountEffectElement = (
  hoverMode: StateMode,
  activeMode: StateMode
) => [hoverMode, activeMode].includes(StateMode.BACKGROUND);

const cssHoverModePresets: Record<StateMode, Maybe<string>> = {
  [StateMode.BACKGROUND]: css.hoverBackground,
  [StateMode.OPACITY]: css.hoverOpacity,
  [StateMode.NONE]: undefined,
} as const;

export const getHoverClassNameByStateMode = (
  mode: StateMode = DEFAULT_STATE_MODE
) => cssHoverModePresets[mode];

const cssActiveModePresets: Record<StateMode, Maybe<string>> = {
  [StateMode.BACKGROUND]: css.activeBackground,
  [StateMode.OPACITY]: css.activeOpacity,
  [StateMode.NONE]: undefined,
};

export const getActiveClassNameByStateMode = (
  mode: StateMode = DEFAULT_STATE_MODE
) => cssActiveModePresets[mode];

export const detectTypeProps = ({ Component }: ClickableProps) =>
  Component === 'button' ? { type: 'button' } : undefined;
